<app-preloader></app-preloader>
<app-navbar #menuBar *ngIf="!isAdminRoute"></app-navbar>
    <router-outlet></router-outlet>
<app-footer *ngIf="!isAdminRoute"></app-footer>

<!-- Modal global de aceptación de aviso de privacidad y términos -->
<app-terms-modal *ngIf="consentModalOpen"
                 [source]="consentModalSource"
                 (accepted)="onConsentAccepted()"
                 (cancelled)="onConsentCancelled()">
</app-terms-modal>